import React, { Component } from 'react';
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Row,
  Alert,
  Spin
 } from 'antd';
 import axios from 'axios';
import '../PriceManagement.css';
import MyModal from '../../Modal';
import { Constant } from "../../../config";

const { TextArea } = Input;

class CostDetail extends Component {

  state = {
    loading: false,
    isEditCost: false,
    costGateWayCountryId: null,
    vendorList: [],
    addCostFromList: false
  };

  componentWillMount() {
    const { isEditCost, data, addCostFromList } = this.props
    this.setState({ isEditCost })

    if (addCostFromList) {
      this.setState({ addCostFromList })
      this._fetchVendorList()
    } else {
      if (isEditCost) {
        this.setState({ costGateWayCountryId: data.id})
        this._fetchCountryCost(data.id)
      }
    }
  }

  componentDidMount() {
    const { isEditCost, addCostFromList, gatewayId } = this.props
    this.props.form.setFieldsValue({
      note: ''
    });

    if (!isEditCost && !addCostFromList) {
      this.props.form.setFieldsValue({
        gateway_id: gatewayId
      });
    }
  }

  _fetchCountryCost = async (id = 0) => {
    this.setState({ loading: true })
    const url = `${Constant.COST_PRICE_GATEWAY_COUNTRY_API.replace("[id]", id)}`;
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    this.setState({ loading: false })
    await this.props.form.setFieldsValue({
      old_price: Number.parseFloat(resp.data.price).toFixed(4),
      note: ''
    });
  }

  _fetchVendorList = async () => {
    const opt = {
      url: `${Constant.COST_PRICE_API}?limit=0`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    let vendorList = []

    if (resp.data) {
      vendorList = resp.data.data;
    }

    this.setState({ 
      vendorList,
      loading: false
    })
  };

  _noteCostPrice = () => {
    let note =''
    if (this.state.isEditCost) {
      note = 'Cost edit will apply only to selected vendor in selected country. The change will immediately apply'
    } else {
      note = 'Cost Price will apply only to selected vendor in selected country. The adding will immediately apply'
    }
    return note
  }


  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        'ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?',
        '',
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.isEditCost ? 'แก้ไข' : 'เพิ่ม';
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const token = localStorage.getItem(Constant.SessionKey);

          // default method & url
          let method = 'PATCH';
          let url = `${Constant.COST_PRICE_GATEWAY_COUNTRY_API.replace("[id]", this.state.costGateWayCountryId)}`;
          if (this.state.isEditCost) {
            delete values.old_price
          }
          values.price = parseFloat(values.price)

          let payload = {
            ...values
          };
          
          // change method & url for add cost
          if (!this.state.isEditCost || this.state.addCostFromList) {
            method = 'POST';
            url = Constant.COST_PRICE_API;
          }

          const opt = {
            data: payload,
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            method,
            url,
          };

          try {
            await axios(opt);
            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, '', async () => {
              this.props.hasActivity()
            });
          } catch (e) {
            this.setState({ loading: false })
            let eMsgDetail = '';
            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ''}] ${tmp.name || ''}`;
            }
            MyModal.error(errorMsg, eMsgDetail);
          }
        },
        'ยืนยัน',
        'ยกเลิก',
      );
    });
  };

	render() {
    const { onCancel, visible, countryList, isEditCost, costCountryName, gatewayName, addCostFromList } = this.props;
    const { getFieldDecorator } = this.props.form;

		return (
      <Modal
        className="my-layout"
        footer={
          <div style={{textAlign: 'center'}}>
            <Button key="cancel" onClick={onCancel}>
              Close
            </Button>
            <Button key="save" type='primary' htmlType="submit" form='cost_price'>
              Save
            </Button>
          </div>
        }
        onCancel={onCancel}
        title={isEditCost ? 'Edit Cost Price' : 'Add Cost'}
        visible={visible}
      >
        <Spin spinning={this.state.loading}>
          {!this.state.addCostFromList && (
            <Alert
              style={{marginBottom: 10}}
              message={
                <Row type='flex' justify="space-around">
                  {isEditCost && (
                    <div>Country: <span style={{ fontSize: 16, fontWeight: 'bold'}}>{costCountryName}</span></div>
                  )}
                  <div>Vendor: <span style={{ fontSize: 16, fontWeight: 'bold'}}>{gatewayName}</span></div>
                </Row>
              }
            />
          )}
          <Form id='cost_price' onSubmit={this.handleSubmit}>
            {!isEditCost && (
              <Form.Item label="Country" style={{marginBottom: 10}}>
                {getFieldDecorator("country_abbr", {
                  rules: [{ required: true, message: 'กรุณาเลือกประเทศ' }],
                })(
                  <Select
                    showSearch
                    placeholder="Select Country"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {(countryList || []).map((item, i) => (
                      <Select.Option key={i} value={item.region_code}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            )}
            {!isEditCost && !addCostFromList && (
              getFieldDecorator('gateway_id')(<Input type="hidden" />)
            )}
            {addCostFromList && (
              <Form.Item label="Vendor" style={{marginBottom: 10}}>
                {getFieldDecorator("gateway_id", {
                  rules: [{ required: true, message: 'กรุณาเลือก Vendor' }],
                })(
                  <Select
                    showSearch
                    placeholder="Select Vendor"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {(this.state.vendorList || []).map((item, i) => (
                      <Select.Option key={i} value={item.gateway_id}>
                        {item.gateway_name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            )}
            {isEditCost && (
              <Form.Item label="Old Cost Rate" style={{marginBottom: 10}}>
                {getFieldDecorator('old_price')(<Input disabled />)}
              </Form.Item>
            )}
              <Form.Item label={isEditCost ? "New Rate" : "Cost Price"} style={{marginBottom: 10}}>
                {getFieldDecorator('price', {
                  rules: [
                    {
                      pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                      message: "กรุณากรอกเป็นตัวเลขและเลขทศนิยมได้ไม่เกิน 4 ตัวเท่านั้น"
                    },
                    { required: true, message: `กรุณากรอก ${isEditCost ? "New Rate" : "Cost Price"}` }
                  ],
                })(<Input placeholder={isEditCost ? "New Rate" : "Cost Price"} />)}
              </Form.Item>
              <Form.Item label={isEditCost ? "Cost Change Note" : "Note"} style={{marginBottom: 10}}>
                {getFieldDecorator('note')(<TextArea rows="3" maxLength={255} />)}
              </Form.Item>
              <p>Note: <span>{this._noteCostPrice()}</span></p>
          </Form>
        </Spin>
      </Modal>
		)
	}
}

export default Form.create({ name: 'cost_price' })(CostDetail);


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/Modals/CostDetail.js